import styled from 'styled-components'

export const EllipsisActionButtons = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    button[popup-depth='1'] {
        max-height: 32px;
        margin-left: 14px;
    }
`
